// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"8e808e7a","301":"9f7c0cde","397":"8e808e7a","444":"20b636f3","876":"b9e1d24a"}[chunkId] + ".chunk.css";
};